import { useState } from "react";
import ArbitrageMonitor from "../components/ArbitrageMonitor";

// Supported trading pairs
const TRADING_PAIRS = [
  { id: "SOL/USDC", name: "SOL / USDC", inputMint: "So11111111111111111111111111111111111111112", outputMint: "EPjFWdd5AufqSSCwMbcXzKinleyLvwYWWk9N7W8vBjn" },
  { id: "SOL/USDT", name: "SOL / USDT", inputMint: "So11111111111111111111111111111111111111112", outputMint: "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB" },
];

// DEX fee comparison
const DEX_INFO = [
  { name: "Raydium", fee: "0.25%", type: "AMM/CLMM" },
  { name: "Orca", fee: "0.05%", type: "Whirlpools" },
  { name: "Jupiter", fee: "0.1%", type: "Aggregator" },
  { name: "Meteora", fee: "Variable", type: "DLMM" },
];

export default function Arbitrage() {
  const [selectedPair, setSelectedPair] = useState("SOL/USDC");

  return (
    <div className="min-h-screen bg-gray-900 text-white p-4 md:p-6 max-w-7xl mx-auto">
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-2xl font-bold flex items-center gap-2">
          ⚡ Solana Arbitrage Bot
        </h1>
        <p className="text-gray-400 text-sm mt-1">
          AI-powered cross-DEX arbitrage opportunity scanner
        </p>
      </div>

      {/* Trading Pair Selector */}
      <div className="mb-4">
        <label className="text-gray-400 text-sm mr-2">Trading Pair:</label>
        <div className="inline-flex gap-2 mt-2">
          {TRADING_PAIRS.map((pair) => (
            <button
              key={pair.id}
              onClick={() => setSelectedPair(pair.id)}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                selectedPair === pair.id
                  ? "bg-purple-600 text-white"
                  : "bg-gray-700 text-gray-300 hover:bg-gray-600"
              }`}
            >
              {pair.name}
            </button>
          ))}
        </div>
      </div>

      {/* Main Arbitrage Monitor */}
      <div className="mb-6">
        <ArbitrageMonitor />
      </div>

      {/* DEX Info */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-gray-800 rounded-xl border border-gray-700 p-4">
          <h3 className="text-lg font-semibold mb-3">📊 DEX Fee Comparison</h3>
          <table className="w-full text-sm">
            <thead>
              <tr className="text-gray-400 border-b border-gray-700">
                <th className="text-left py-2">DEX</th>
                <th className="text-left py-2">Fee</th>
                <th className="text-left py-2">Type</th>
              </tr>
            </thead>
            <tbody>
              {DEX_INFO.map((dex) => (
                <tr key={dex.name} className="border-b border-gray-700/50">
                  <td className="py-2">{dex.name}</td>
                  <td className="py-2 text-green-400">{dex.fee}</td>
                  <td className="py-2 text-gray-400">{dex.type}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="bg-gray-800 rounded-xl border border-gray-700 p-4">
          <h3 className="text-lg font-semibold mb-3">💰 Profitability Formula</h3>
          <div className="font-mono text-sm bg-gray-900 p-3 rounded-lg">
            <p className="text-gray-400 mb-2">Net Profit =</p>
            <p className="mb-1">(Spread % − Fees % − Slippage %) × Size</p>
            <p className="text-gray-500">− Priority Fee − Jito Tip</p>
          </div>
          <div className="mt-3 text-sm text-gray-400">
            <p className="mb-1">
              <span className="text-yellow-400">Example:</span> 0.4% spread,
              $10k trade
            </p>
            <p className="text-xs">
              Gross: $40 − Fees: $15 − Slippage: $5 − Fees: $0.55 ={" "}
              <span className="text-green-400">$19.45 net</span>
            </p>
          </div>
        </div>
      </div>

      {/* Cost Breakdown */}
      <div className="mt-6 bg-gray-800 rounded-xl border border-gray-700 p-4">
        <h3 className="text-lg font-semibold mb-3">⚠️ Cost Breakdown</h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
          <div className="bg-gray-900/50 p-3 rounded-lg">
            <p className="text-gray-400">DEX Fees</p>
            <p className="text-red-400">0.05% - 0.25% per leg</p>
          </div>
          <div className="bg-gray-900/50 p-3 rounded-lg">
            <p className="text-gray-400">Slippage</p>
            <p className="text-red-400">~0.2% expected</p>
          </div>
          <div className="bg-gray-900/50 p-3 rounded-lg">
            <p className="text-gray-400">Priority Fee</p>
            <p className="text-red-400">~$0.001 SOL</p>
          </div>
          <div className="bg-gray-900/50 p-3 rounded-lg">
            <p className="text-gray-400">Jito Tip</p>
            <p className="text-red-400">~$0.001 SOL</p>
          </div>
        </div>
      </div>

      {/* Documentation Link */}
      <div className="mt-6 p-4 bg-blue-900/20 border border-blue-700 rounded-lg">
        <p className="text-sm">
          📖 Full strategy guide:{" "}
          <a
            href="/docs/solana-arbitrage-strategies-2025.md"
            className="text-blue-400 hover:underline"
          >
            Solana Arbitrage Strategies 2025
          </a>
        </p>
      </div>
    </div>
  );
}